import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './UserDetailsForm.css';

const UserDetailsForm = ({ onFormSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company_name: '',
    contact_number: '',
  });

  const [isValid, setIsValid] = useState(true);
  const [errors, setErrors] = useState({});
  const [selectedCountry, setSelectedCountry] = useState('IN'); // Default country code

  // Effect to disable scrolling on mount and enable on unmount
  useEffect(() => {
    // Disable scrolling when the form is open
    document.body.classList.add('no-scroll');

    // Cleanup function to re-enable scrolling
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []); // Empty dependency array to run only on mount and unmount

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    // Clean phone number if the country is India
    if (selectedCountry === 'IN' && value) {
      // Remove leading zeros if present
      value = value.replace(/^\+91(0+)/, '+91');
    }
    setFormData({ ...formData, contact_number: value });
  };

  const handleCountryChange = (country) => {
    setSelectedCountry(country);
  };

  const validatePhoneNumber = () => {
    if (selectedCountry !== 'IN') {
      return true; // Skip validation if the country is not India
    }
    const phoneNumber = formData.contact_number;
    // console.log(phoneNumber);
    const phoneRegex = /^\+91[1-9]\d{9}$/; // Regex for +91 followed by 10 digits

    return phoneRegex.test(phoneNumber);
  };

  const validateEmail = () => {
    const email = formData.email;
    // Regular expression for validating an Email
    const emailRegex = /^[\w\-\.]+@([\w-]+\.)+[a-zA-Z]{2,}$/;

    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = {};
    
    // Validate phone number only if country is IN
    if (!validatePhoneNumber()) {
      errors.contact_number = 'Invalid phone number length for selected country';
    }

    // Validate email
    if (!validateEmail()) {
      errors.email = 'Invalid email format';
    }
    
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      setIsValid(false);
      return;
    }

    setIsValid(true);
    setErrors({});

    const btn = document.querySelector("#btn");
    const btnText = document.querySelector("#btnText");

    btnText.innerHTML = "Submitting...";
    btn.classList.add("active");

    try {
      const response = await fetch('https://chatbotappbackend.azurewebsites.net/insert', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const result = await response.json();
        onFormSubmit(result);
        btnText.innerHTML = "Thanks";
      } else {
        // console.error('Failed to submit form');
        btnText.innerHTML = "Submit";
        btn.classList.remove("active");
      }
    } catch (error) {
      // console.error('Error:', error);
      btnText.innerHTML = "Submit";
      btn.classList.remove("active");
    }
  };

  return (
    <div className='user'>
      <div className="user-form">
        <form onSubmit={handleSubmit}>
          <label htmlFor="name"></label>
          <input
            type="text"
            id="name"
            name="name"
            className="form-input"
            placeholder='Name *'
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            id="email"
            name="email"
            className={`form-input ${errors.email ? 'input-error' : ''}`}
            placeholder='Email *'
            value={formData.email}
            onChange={handleChange}
            required
          />

          <div className='phone-input-container'>
            <label htmlFor="contact_number"></label>
            <PhoneInput
              id="contact_number"
              className={`form-input ${errors.contact_number ? 'input-error' : ''}`}
              placeholder='Contact Number *'
              name="contact_number"
              value={formData.contact_number}
              onChange={handlePhoneChange}
              defaultCountry="IN" // Default country code (India)
              onCountryChange={handleCountryChange} // Handle country change
              required
            />
          </div>

          <label htmlFor="company_name"></label>
          <input
            type="text"
            id="company_name"
            name="company_name"
            className="form-input"
            placeholder='Company Name'
            value={formData.company_name}
            onChange={handleChange}
          />

          <div className="container">
            <button id="btn" type="submit">
              <p id="btnText">Submit</p>
              <div className="check-box">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                  <path fill="transparent" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserDetailsForm;
